import apiClient from './apiClient'


const getScheduleTemplates = (tenant, skip, take, search, orderBy, desc) => {
  const params = {
    skip,
    take,
    keyword: search,
    orderBy,
    desc
  }
  return apiClient.get(`/${tenant}/ScheduleTemplate`, { params })
}

const getScheduleTemplate = (tenant, id) => {
  return apiClient.get(`/${tenant}/ScheduleTemplate/${id}`)
}

const createScheduleTemplate = (tenant, template) => {
  return apiClient.post(`/${tenant}/ScheduleTemplate`, template)
}

const updateScheduleTemplate = (tenant, id, template) => {
  return apiClient.put(`/${tenant}/ScheduleTemplate/${id}`, template)
}

const deleteScheduleTemplate = (tenant, id) => {
  return apiClient.delete(`/${tenant}/ScheduleTemplate/${id}`)
}


export default {
  getScheduleTemplates,
  getScheduleTemplate,
  createScheduleTemplate,
  updateScheduleTemplate,
  deleteScheduleTemplate
}
